import * as React from "react";

import type {
  AppContextualMenuPropsCurrent,
  AppContextMenuProps,
} from "./AppContextualMenu.types";
import { useAppContextualMenu } from "./useAppContextualMenu";
import { renderAppContextualMenu } from "./renderAppContextualMenu";

export const AppContextualMenu = React.memo(
  React.forwardRef<HTMLDivElement, AppContextualMenuPropsCurrent>(
    (props, _ref) => {
      // update this to return the state type.
      // hook to manage the state of your CM component. This hook takes the props and ref and returns the state.
      const state = useAppContextualMenu(props as AppContextMenuProps);

      return renderAppContextualMenu(state);
    }
  )
);

AppContextualMenu.displayName = "next/AppContextualMenu";
